/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyContactModel } from '../../models/client-survey-contact-model';
import { CreateSurveyContactRequest } from '../../models/create-survey-contact-request';

export interface CreateSurveyContactAsync$Plain$Params {
  
    /**
     * properties of surveycontact item to create
     */
    body?: CreateSurveyContactRequest
}

export function createSurveyContactAsync$Plain(http: HttpClient, rootUrl: string, params?: CreateSurveyContactAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
  const rb = new RequestBuilder(rootUrl, createSurveyContactAsync$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyContactModel>;
    })
  );
}

createSurveyContactAsync$Plain.PATH = '/api/SurveyContact';
